import React from "react";
import { Link } from "react-router-dom";

/**
 * Pond-level workflow tabs (read-only super panel; matches AdminPanel Update Pond nav).
 * @param {{ pondId: string|number, active: 'general'|'feed'|'stocking'|'sampling' }} props
 */
export default function PondWorkflowTabs({ pondId, active }) {
  const pid = pondId != null && pondId !== "" ? String(pondId) : "";
  if (!pid) return null;

  const tabClass = (key) =>
    `nav-link px-3 py-2 rounded-top${active === key ? " donezo-tab-active" : ""}`;

  return (
    <div className="card border-0 shadow-sm mb-4 donezo-workflow-tabs">
      <ul className="nav nav-tabs border-0">
        <li className="nav-item me-2">
          <Link to={`/updatePond/${pid}`} className={tabClass("general")}>
            <i className="fas fa-cog me-2" aria-hidden />
            General
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/pondFeedFertilization/${pid}`} className={tabClass("feed")}>
            <i className="fas fa-leaf me-2" aria-hidden />
            Feed &amp; Fertilization
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/pondStocking/${pid}`} className={tabClass("stocking")}>
            <i className="fas fa-water me-2" aria-hidden />
            Stocking Data
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/pondDetailViaPond/${pid}`} className={tabClass("sampling")}>
            <i className="fas fa-chart-line me-2" aria-hidden />
            Fishing / Sampling Data
          </Link>
        </li>
      </ul>
    </div>
  );
}
